import CreateEntity from './CreateEntity'

export default CreateEntity
